import React from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { userOrder } from '../../states/userOrder';
import { ToastContainer, toast } from 'react-toastify';
import { apiGet, apiPost } from '../../utils/api';
import { configShop } from '../../states/configShop';
const ShopAddLocal = ({ setOpenModal }) => {
    const { dataConfig } = configShop();
    const { setDataUser } = userOrder();
    const [shops, setShops] = useState([]);
    const guardarInfo = async () => {
        if (shops.length === 0) {
            toast.error("Seleccione Tienda", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
            });
        } else {
            setDataUser({
                popAddress: false,
                uuidShop: shops.uuid,
                shopData: shops,
                deliveryMethod: 0,
            })
            setOpenModal(false);
        }
    };
    const onSubmit = (e) => {
        e.preventDefault();
    };
    const [listaShops, setListaShops] = useState([]);
    const obtenerShop = async () => {
        const respuesta = await apiGet('/shops');
        let infoShops = respuesta.data;
        setListaShops(infoShops);
    };
    useEffect(() => {
        obtenerShop();
    }, []);
    const opciones = listaShops.map((ciudad) => ({
        label: ciudad.name,   // lo puedes usar solo de referencia
        value: ciudad.uuid,
        name: ciudad.name,
        address: ciudad.address,
        city: ciudad?.city,
    }));
    const customStyles = {
        container: (provided) => ({
            ...provided,
            width: "100%",
            marginBottom: "10px",
            zIndex: 1100,
        }),

        control: (provided) => ({
            ...provided,
            width: "100%",
            minHeight: "48px", // opcional, estilo móvil
            zIndex: 1100,
        }),
        menu: (provided) => ({
            ...provided,
            width: "100%",
            zIndex: 1100,
        }),
    };
    return (
        <div class="App">
            <div className="containerPrincipal">
                <div className="new-form" >
                    <div className="container-titulo-iniciar-sesion">
                        <Select
                            id="sucursales"
                            className="options"
                            options={opciones}
                            formatOptionLabel={(opcion) => (
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span style={{ fontWeight: "500" }}>{opcion.name}</span>
                                    <span style={{ fontSize: "12px", color: "#666" }}>{opcion.address},{opcion.city}</span>
                                </div>
                            )}
                            styles={customStyles}
                            onChange={(e) => {
                                console.log(e);
                                setShops(e)
                            }}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 12,
                                width: 280,
                                zIndex: 1100,
                                position: "absolute"
                            })}
                        />
                    </div>

                    <div style={{
                        width: "100%",
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px",
                        padding: "12px 16px",
                        zIndex: '1 !important'
                    }}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <button
                                onClick={guardarInfo}
                                className="boton-home-v2" style={{ "--btn-color": dataConfig?.color_botton, "--btn-text-color": dataConfig?.color_button_text, width: "100%" }}>
                                <p className="boton-title-v2">Consultar</p>
                            </button>
                        </div>
                    </div>


                </div>
            </div>
      
        </div>
    );
};

export default ShopAddLocal;
